import { Injectable } from '@angular/core';
import { Observable, from, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { FormGroup } from "@angular/forms";
import { FindFilter } from "projects/rms/app/api/models/find-filter";

import { UserService } from "projects/rms/app/api/services/user.service";

import { UserPreferenceModel } from "projects/rms/app/api/models/user-preference-model";
import { UserPreferenceService } from 'projects/rms/app/api/services/user-preference.service';
import { ToastService } from 'projects/shared/core/services/toast.service';

@Injectable({
  providedIn: 'root'
})
export class UserPreferencesService {

  static userId = 0;
  static userPreferences: UserPreferenceModel[] = [];

  constructor(private rmsUserService: UserService, private userPreferenceService: UserPreferenceService, private toastService: ToastService) { }

  //Returns userPreference with preferenceName equal to key. If key is an array of keys, it will return the values for all of them.
  //Unset preferences return null.
  public get(key: string | string[]): Observable<any> {
    if (Array.isArray(key)) {
      if (!UserPreferencesService.userId) { //if userId isn't set, cache the user
        return from(this.cacheUser()).pipe(
          switchMap(() =>
            Promise.all(
              key.map(k =>
                UserPreferencesService.userPreferences.find(i => i.preferenceName == k)
              )
            )
          )
        )
      } else {
        return from(Promise.all(key.map(k =>
          UserPreferencesService.userPreferences.find(i => i.preferenceName == k)
        )));
      }
    }

    if (!UserPreferencesService.userId) { //if userId isn't set, cache the user
      return from(this.cacheUser()).pipe(                                                                 //from() takes a promise and converts it to an observable, letting rxjs take over
        switchMap(() => of(UserPreferencesService.userPreferences.find(i => i.preferenceName == key)))    //switchMap() replaces the cacheUser observable (which we were going to return but don't want to) with a userPreferences.find() Observable (which we do want to return)
      )
    } else {
      return of(UserPreferencesService.userPreferences.find(i => i.preferenceName == key));   //of() just converts its argument into an observable that next's that argument, I think
    }
  }

  //Creates or replaces userPreference with preferenceName equal to key
  public set(key: string, value: string) {
    const update = () => {
      //push the new value to the database
      this.userPreferenceService.Update({ userId: UserPreferencesService.userId, preferenceName: key, preferenceValue: value }).subscribe(data => {
        if (data) { //if we get a good value back from the database, push it to the cached list
          console.log("Data returned from server!", data);
          UserPreferencesService.userPreferences = UserPreferencesService.userPreferences.filter(i => i.preferenceName != data.preferenceName);
          UserPreferencesService.userPreferences.push(data);
        } else {
          console.log("Server is not returning data.....");
        }
      }, error => {
        this.toastService.showError(error);
      })
    }

    if (!UserPreferencesService.userId) { //if userId isn't set, cache the user
      this.cacheUser().then(() => {
        update();
      })
    } else {
      update();
    }
  }

  //Caches user's preferences, called by either get() or set() first time only
  private cacheUser(): Promise<void> {
    return new Promise((resolve) => {
      this.rmsUserService.GetCurrent().subscribe(
        (data => {
          var userId = data.model?.id
          if (userId) {
            let filter: FindFilter = {
              findKeys: {
                "UserId": userId + ''
              },
              pagingInfo: {
                pageNumber: 0,
                pageSize: 1000
              }
            };
            this.userPreferenceService.FindInDomain(filter).subscribe(
              (data => {
                UserPreferencesService.userId = userId;
                UserPreferencesService.userPreferences = data.filter(item => typeof item === 'object'); //remove the TotalRecordCount entry, which we don't need
                resolve();
              })
            );
          }
        })
      );
    })
  }

}
